/** Agent Forge v1 landing (empty composer). */
export const AGENT_FORGE_LANDING_PATH = '/agent';

const AGENT_FORGE_THREAD_PREFIX = '/agent/c';

const normalizePathname = (pathname: string): string =>
  pathname.length > 1 && pathname.endsWith('/')
    ? pathname.slice(0, -1)
    : pathname;

/** Deep link for an inline thread (`/agent/c/<sessionId>`). */
export const agentForgeThreadPath = (sessionId: string): string =>
  `${AGENT_FORGE_THREAD_PREFIX}/${sessionId}`;

/** True on `/agent` or `/agent/` only (not thread URLs under `/agent/c/...`). */
export const isAgentForgeLandingPath = (pathname: string): boolean =>
  normalizePathname(pathname) === AGENT_FORGE_LANDING_PATH;

/** True when pathname is an inline thread URL with a non-empty session id. */
export const isAgentForgeThreadPath = (pathname: string): boolean => {
  const n = normalizePathname(pathname);
  if (!n.startsWith(`${AGENT_FORGE_THREAD_PREFIX}/`)) return false;
  const rest = n.slice(AGENT_FORGE_THREAD_PREFIX.length + 1);
  return rest.length > 0;
};

// Routes where the bar must NOT render.
// Keep patterns explicit; no startsWith() ambiguity.
export const HIDDEN_PATH_PATTERNS: readonly RegExp[] = [
  /^\/login(\/|$)/,
  /^\/signup(\/|$)/,
  /^\/assessment(\/|$)/,
  /^\/candidate-survey(\/|$)/,
  /^\/integrations\/oauth(\/|$)/,
];

export const isHiddenPath = (pathname: string): boolean =>
  HIDDEN_PATH_PATTERNS.some((p) => p.test(pathname));
